<script setup lang="ts">
import { onMounted, watch, ref } from "vue";

import { NOTIFICATIONS_TIMEOUT } from "../constants";

export interface NotificationsProps {
  value: unknown;
  showValue: unknown;
  time?: number;
  eagerCheck?: boolean;
}

const emit = defineEmits<{
  (event: "close"): void;
}>();

const props = withDefaults(defineProps<NotificationsProps>(), {
  time: NOTIFICATIONS_TIMEOUT,
  eagerCheck: false,
});

const isVisible = ref<boolean>(false);

const handleShow = () => {
  isVisible.value = true;

  setTimeout(() => {
    isVisible.value = false;

    emit("close");
  }, props.time);
};

watch(
  () => props.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      if (newValue === props.showValue) {
        handleShow();
      } else {
        isVisible.value = false;

        emit("close");
      }
    }
  }
);

onMounted(() => {
  if (props.eagerCheck && props.value === props.showValue) {
    handleShow();
  }
});
</script>

<template>
  <span
    v-if="isVisible"
    @click="
      () => {
        isVisible = false;
        emit('close');
      }
    "
  >
    <slot />
  </span>
</template>

<style scoped lang="scss"></style>
